import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, Trophy } from 'lucide-react';
import TrackLeaderboard from '@/components/telemetry/TrackLeaderboard';
import LiveLeaderboard from '@/components/telemetry/LiveLeaderboard';
import { TRACK_BOARDS } from '@/lib/trackBoards';

export default function Leaderboard() {
  const [searchParams] = useSearchParams();
  const trackParam = searchParams.get('track');
  const deepLinkedTrack = trackParam || '';

  useEffect(() => {
    if (!deepLinkedTrack) return;
    const el = document.getElementById(`track-${deepLinkedTrack}`);
    if (!el) return;
    // Allow paint before scrolling.
    const raf = requestAnimationFrame(() => {
      const headerOffset = parseInt(
        window.getComputedStyle(document.documentElement).getPropertyValue('--header-offset'),
        10
      ) || 64;
      const top = el.getBoundingClientRect().top + window.scrollY - headerOffset - 16;
      window.scrollTo({ top, behavior: 'smooth' });
    });
    return () => cancelAnimationFrame(raf);
  }, [deepLinkedTrack]);

  return (
    <div className="min-h-screen bg-background pt-16">
      <div className="border-b border-white/5">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 py-8">
          <Link to="/" className="inline-flex items-center gap-1.5 text-white/40 hover:text-white text-xs font-bold tracking-widest mb-4 transition-colors">
            <ArrowLeft className="w-3.5 h-3.5" /> BACK TO HOME
          </Link>
          <div className="flex items-center gap-3">
            <Trophy className="w-6 h-6 text-primary" />
            <div>
              <p className="text-primary text-[10px] font-bold tracking-widest mb-1">FASTEST LAPS</p>
              <h1 className="text-white font-black text-2xl md:text-3xl uppercase tracking-tight leading-none">Leaderboard</h1>
              <p className="text-white/40 text-xs mt-1.5">Live lap times & all-time records set on the Motion Reality rigs</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-8 space-y-8">
        <LiveLeaderboard />
        {TRACK_BOARDS.map((b) => (
          <TrackLeaderboard
            key={b.title}
            {...b}
            deepLinked={deepLinkedTrack === b.trackKey}
          />
        ))}
      </div>
    </div>
  );
}